import React from "react";

function TermsPage() {
  return (
    <div style={{ margin: "auto", width: "calc(100% - 20px)", maxWidth: 700 }}>
      <h1>Modifiche ai nostri termini e condizioni</h1>
      <p>
        L'utente riconosce e accetta che LaBraseria può interrompere (in modo
        permanente o temporaneo) la fornitura del Servizio (o di qualsiasi
        funzione all'interno del Servizio) all'utente o agli utenti in generale
        a sua esclusiva discrezione, senza preavviso. L'utente può smettere di
        utilizzare il Servizio in qualsiasi momento. Non è necessario che
        l'utente informi specificamente LaBraseria quando smette di utilizzare
        il Servizio. L'utente riconosce e accetta che se LaBraseria disabilita
        l'accesso al suo account, potrebbe essergli impedito di accedere al
        Servizio, ai dati del suo account o a qualsiasi file o altro materiale
        contenuto nel suo account.
      </p>
      <p>
        Se decidiamo di modificare i nostri Termini e condizioni, pubblicheremo
        tali modifiche su questa pagina e/o aggiorneremo le modifiche ai Termini
        e condizioni. modifiche su questa pagina e/o aggiorneremo la data di
        modifica dei Termini e Condizioni di modifica dei Termini e Condizioni.
      </p>

      <h1>Modifiche alla nostra applicazione</h1>
      <p>
        LaBraseria si riserva il diritto di modificare, sospendere o
        interrompere, temporaneamente o permanentemente, l'applicazione o
        qualsiasi servizio a cui si collega, con o senza preavviso e senza
        alcuna responsabilità nei confronti dell'utente.
      </p>

      <h1>Updates to Our app</h1>
      <p>
        LaBraseria può di tanto in tanto fornire miglioramenti o perfezionamenti
        alle caratteristiche/funzionalità dell'applicazione. alle
        caratteristiche/funzionalità dell'applicazione, che possono includere
        patch, bug correzioni di bug, aggiornamenti, upgrade e altre modifiche
        ("Aggiornamenti").
      </p>
      <p>
        Gli aggiornamenti possono modificare o eliminare alcune caratteristiche
        e/o funzionalità dell'applicazione. dell'applicazione. L'utente accetta
        che LaBraseria non ha alcun obbligo di (i) fornire aggiornamenti o (ii)
        continuare a fornire o abilitare particolari caratteristiche.
        Aggiornamenti, o (ii) continuare a fornire o abilitare particolari
        caratteristiche e/o funzionalità dell'applicazione.
      </p>
      <p>
        L'utente accetta inoltre che tutti gli aggiornamenti saranno (i)
        considerati parte integrante dell'applicazione e (ii) soggetti ai
        termini e alle condizioni del presente Contratto.
      </p>

      <h1>Servizi di terze parti</h1>
      <p>
        Possiamo visualizzare, includere o rendere disponibili contenuti di
        terzi (tra cui dati, informazioni, applicazioni e altri
        prodotti-servizi) o fornire link a siti web o servizi di terzi ("Servizi
        di terzi"). link a siti web o servizi di terzi ("Servizi di terzi").
      </p>
      <p>
        L'utente riconosce e accetta che LaBraseria non sarà responsabile per
        dei Servizi di Terze Parti, inclusa la loro accuratezza, completezza,
        tempestività, validità, conformità al copyright, legalità, decenza,
        qualità, tempestività, validità, conformità al diritto d'autore,
        legalità, decenza, qualità o qualsiasi altro aspetto degli stessi.
        LaBraseria non si assume e non avrà responsabilità nei confronti
        dell'utente o di qualsiasi altra persona o entità per i Servizi di
        terzi. persona o entità per qualsiasi Servizio di terze parti.
      </p>
      <p>
        I Servizi di terze parti e i relativi link sono forniti esclusivamente
        come comodità per l'utente e l'accesso e l'utilizzo di tali servizi
        avviene a proprio rischio e pericolo e in base ai termini e alle
        condizioni di tali terze parti.
      </p>

      <h1>Termine e cessazione</h1>
      <p>
        Il presente Contratto rimarrà in vigore fino alla sua risoluzione da
        parte dell'utente o di LaBraseria.
      </p>
      <p>
        LaBraseria può, a sua esclusiva discrezione, in qualsiasi momento e per
        qualsiasi motivo, sospendere o risolvere il presente Contratto con o
        senza preavviso.
      </p>
      <p>
        Il presente Contratto si risolverà immediatamente, senza preavviso da
        parte di LaBraseria, nel caso in cui l'utente non rispetti una qualsiasi
        disposizione del presente Contratto. L'utente può inoltre risolvere il
        presente Contratto cancellando l'applicazione e tutte le sue copie dal
        proprio computer.
      </p>
      <p>
        In caso di risoluzione del presente Contratto, l'utente dovrà cessare
        l'utilizzo dell'applicazione e cancellare tutte le copie
        dell'applicazione dal proprio computer. e cancellare tutte le copie
        dell'applicazione dal proprio computer.
      </p>
      <p>
        La risoluzione del presente Contratto non limiterà alcun diritto o
        rimedio di LaBraseria LaBraseria non limiterà alcun diritto o rimedio di
        legge o di equità in caso di violazione da parte dell'utente (durante la
        durata del presente Accordo) di uno qualsiasi degli obblighi assunti
        dall'utente ai sensi del presente Accordo.
      </p>

      <h1>Avviso di violazione del copyright</h1>
      <p>
        Se l'utente è un titolare di copyright o un suo agente e ritiene che il
        materiale presente sull'applicazione materiale presente sulla nostra
        applicazione costituisca una violazione del vostro copyright, vi
        preghiamo di contattarci indicando le seguenti informazioni: (a) una (a)
        una firma fisica o elettronica del titolare del copyright o di una
        persona (a) una firma fisica o elettronica del titolare del copyright o
        di una persona autorizzata ad agire per suo conto; (b) l'identificazione
        del materiale che si ritiene violare materiale che si sostiene essere
        oggetto di violazione; (c) le informazioni di contatto, tra cui
        indirizzo, numero di telefono e indirizzo e-mail; (d) una dichiarazione
        dell'utente che che l'utente ritiene in buona fede che l'uso del
        materiale non è autorizzato dai proprietari del copyright; e (e) una
        dichiarazione che le informazioni contenute nella notifica sono accurate
        e informazioni contenute nella notifica sono accurate e, sotto pena di
        falsa testimonianza, siete autorizzati ad agire per conto del titolare.
      </p>

      <h1>Indennizzo</h1>
      <p>
        L'utente accetta di indennizzare e trattenere LaBraseria e le sue
        società madri, controllate, affiliate, funzionari, dipendenti, agenti,
        partner e licenziatari (se presenti) da qualsiasi reclamo o richiesta,
        comprese le ragionevoli spese legali, dovute o derivanti da: (a) uso
        dell'applicazione dell'applicazione; (b) violazione del presente
        Contratto o di qualsiasi legge o regolamento; o (c) violazione di
        qualsiasi diritto di terzi.
      </p>

      <h1>Nessuna garanzia</h1>
      <p>
        L'applicazione viene fornita all'utente "COSÌ COM'È" e "COME
        DISPONIBILE" e con tutti i difetti e le mancanze senza alcun tipo di
        garanzia. Nella misura massima consentita dalla legge applicabile,
        LaBraseria, per conto proprio e per conto delle sue affiliate e dei suoi
        rispettivi licenziatari e fornitori di servizi, declina espressamente
        tutte le garanzie, espresse, implicite, legali o di altro tipo, in
        relazione all'applicazione, comprese tutte le garanzie implicite di
        commerciabilità, idoneità per uno scopo particolare, titolo e non
        violazione, e le garanzie che possono derivare da un corso di
        trattativa, di esecuzione, di uso o di pratica commerciale. Senza
        limitazione a quanto precede, LaBraseria non fornisce alcuna garanzia o
        impegno garanzia o impegno e non dichiara in alcun modo che
        l'applicazione soddisferà soddisferà i requisiti dell'utente,
        raggiungerà i risultati previsti, sarà compatibile o compatibile o
        funzionante con qualsiasi altro software, sistema o servizio, che
        funzionerà senza interruzione, che soddisfi gli standard di prestazione
        o affidabilità o che sia priva di errori o che eventuali errori o
        difetti possano o che eventuali errori o difetti possano essere o
        saranno corretti.
      </p>
      <p>
        Senza limitarsi a quanto sopra, né LaBraseria né alcun fornitore di
        LaBraseria LaBraseria né alcun fornitore di LaBraseria rilascia alcuna
        dichiarazione o garanzia di alcun tipo, espressa o implicita implicita:
        (i) in merito al funzionamento o alla disponibilità dell'applicazione, o
        alle informazioni, ai contenuti, ai materiali o ai prodotti in essa
        inclusi; (ii) in merito al funzionamento o alla disponibilità della
        informazioni, contenuti, materiali o prodotti in essa inclusi; (ii) che
        l'applicazione sarà ininterrotta o priva di errori; (iii) in merito alla
        accuratezza, affidabilità o attualità di qualsiasi informazione o
        contenuto forniti tramite l'applicazione; o (iv) che l'applicazione, i
        suoi server, il contenuti, o le e-mail inviate da o per conto di
        LaBraseria siano privi di virus, script, cavalli di Troia, worm,
        malware, bombe a tempo o altri componenti componenti dannosi.
      </p>
      <p>
        Alcune giurisdizioni non consentono l'esclusione o la limitazione delle
        garanzie implicite o la limitazione dei diritti legali applicabili.
        garanzie implicite o le limitazioni dei diritti legali applicabili a un
        consumatore. di un consumatore, per cui alcune o tutte le esclusioni e
        limitazioni di cui sopra potrebbero non essere applicabili.
      </p>

      <h1>Limitazione di responsabilità</h1>
      <p>
        A prescindere da eventuali danni che l'utente potrebbe subire, l'intera
        responsabilità di LaBraseria e dei suoi fornitori di LaBraseria e di
        qualsiasi suo fornitore in virtù di qualsiasi disposizione del presente
        Contratto e il rimedio esclusivo dell'utente per tutto ciò sarà limitata
        all'importo effettivamente pagato dall'utente per l'applicazione.
      </p>
      <p>
        Nella misura massima consentita dalla legge applicabile, in nessun caso
        LaBraseria o i suoi fornitori saranno responsabili per danni speciali,
        incidentali, indiretti o consequenziali di qualsiasi tipo (inclusi, ma
        non solo, i danni alla salute), danni indiretti o consequenziali di
        qualsiasi tipo (inclusi, ma non limitati a danni per perdita di
        profitti, per perdita di dati o altre informazioni, per interruzione
        dell'attività informazioni, per interruzione dell'attività, per lesioni
        personali, per la perdita di privacy derivanti da o in qualsiasi modo
        correlati all'uso o all'impossibilità di utilizzare l'app, il software
        di terzi e/o la di utilizzare l'applicazione, il software di terze parti
        e/o l'hardware di terze parti utilizzato con l'applicazione, o comunque
        in relazione a qualsiasi disposizione del presente Contratto), anche nel
        caso in cui LaBraseria o qualsiasi fornitore sia stato avvisato della
        possibilità di tali possibilità di tali danni e anche nel caso in cui il
        rimedio fallisca il suo scopo essenziale.
      </p>
      <p>
        Alcuni stati/giurisdizioni non consentono l'esclusione o la limitazione
        di danni incidentali o consequenziali, pertanto la limitazione o
        l'esclusione di cui sopra potrebbe non essere applicabile. esclusione
        potrebbero non essere applicabili.
      </p>

      <h1>Severità</h1>
      <p>
        Se una qualsiasi disposizione del presente Contratto è ritenuta
        inapplicabile o non valida, tale disposizione sarà modificata e
        interpretata in modo da realizzare gli obiettivi di tale disposizione
        nella massima misura possibile ai sensi della legge legge applicabile e
        le restanti disposizioni continueranno a essere in vigore ed effetto.
      </p>
      <p>
        Il presente Contratto, unitamente all'Informativa sulla privacy e a
        qualsiasi altro avviso legale pubblicato da LaBraseria sui Servizi.
        pubblicati da LaBraseria sui Servizi, costituiranno il accordo completo
        tra l'utente e LaBraseria in merito ai Servizi. Se qualsiasi
        disposizione del presente Contratto sia ritenuta non valida da un
        tribunale di giurisdizione competente, l'invalidità di tale disposizione
        non pregiudicherà pregiudicare la validità delle restanti disposizioni
        del presente Accordo, che rimarranno rimarranno in pieno vigore ed
        effetto. Nessuna rinuncia a qualsiasi termine del presente Contratto
        sarà considerata un'ulteriore o continua rinuncia a tale termine o a
        qualsiasi altro termine. termine o di qualsiasi altro termine, e la
        mancata rivendicazione da parte di LaBraseria di un diritto o di una
        disposizione ai sensi del presente Contratto non costituirà una rinuncia
        a tale diritto o disposizione. L'UTENTE E LaBraseria CONVENGONO CHE
        QUALSIASI CAUSA DI AZIONE DERIVANTE DA O CORRELATA AI SERVIZI DEVE
        ESSERE AVVIATA ENTRO UN (1) ANNO DALLA MATURAZIONE DELLA CAUSA DI
        AZIONE. IN CASO CONTRARIO, TALE CAUSA DI AZIONE È DEFINITIVAMENTE
        PRECLUSA.
      </p>

      <h1>Rinuncia</h1>
      <p>
        Fatta eccezione per quanto previsto nel presente documento, il mancato
        esercizio di un diritto o la mancata richiesta di di un obbligo ai sensi
        del presente Accordo non pregiudicherà la possibilità di una la facoltà
        di una parte di esercitare tale diritto o di richiedere tale adempimento
        in in qualsiasi momento successivo, né la rinuncia a una violazione
        costituirà una rinuncia a qualsiasi rinuncia a qualsiasi violazione
        successiva.
      </p>
      <p>
        Il mancato o ritardato esercizio, da parte di una delle parti, di un
        diritto o di una facoltà ai sensi del presente Accordo di una delle
        parti, di un diritto o di un potere ai sensi del presente Accordo,
        costituirà una rinuncia a tale diritto o potere. rinuncia a tale diritto
        o potere. Né l'esercizio singolo o parziale di un diritto o di una
        facoltà ai sensi del presente Accordo non precluderà l'ulteriore
        esercizio di quel tale diritto o di qualsiasi altro diritto qui
        concesso. In caso di conflitto tra il presente Contratto e qualsiasi
        altro termine di acquisto o di altro tipo, prevarranno i termini del
        presente Contratto. termini del presente Contratto.
      </p>

      <h1>Modifiche al presente Accordo</h1>
      <p>
        LaBraseria si riserva il diritto, a sua esclusiva discrezione, di
        modificare o sostituire il presente Accordo in qualsiasi momento.
        sostituire il presente Accordo in qualsiasi momento. In caso di
        modifiche sostanziali, LaBraseria fornire un preavviso di almeno 30
        giorni prima dell'entrata in vigore dei nuovi termini. Ciò che
        costituisce una modifica sostanziale sarà determinato a nostra esclusiva
        discrezione.
      </p>
      <p>
        Continuando ad accedere o a utilizzare la nostra applicazione dopo
        l'entrata in vigore di eventuali revisioni, l'utente accetta di essere
        vincolato alle l'utente accetta di essere vincolato ai termini rivisti.
        Se non si accettano accettare i nuovi termini, non si è più autorizzati
        a utilizzare LaBraseria.
      </p>

      <h1>Intero accordo</h1>
      <p>
        Il Contratto costituisce l'intero accordo tra l'utente e LaBraseria in
        merito all'utilizzo dell'applicazione da parte dell'utente e sostituisce
        tutti gli accordi precedenti e contemporanei, scritti o orali, tra
        l'utente e LaBraseria. accordi scritti o orali precedenti e
        contemporanei tra l'utente e LaBraseria.
      </p>
      <p>
        L'utente può essere soggetto a ulteriori termini e condizioni che si
        applicano quando l'uso o l'acquisto di altri servizi di LaBraseria, che
        LaBraseria vi fornirà al momento dell'uso o dell'acquisto. fornirà
        all'utente al momento di tale utilizzo o acquisto.
      </p>
    </div>
  );
}

export default TermsPage;
